//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Creates a new material.
 * @param dto Dto with data for creation.
 * @return Dto with material's data.
 */
export function create(dto: Types.CreateMaterialDto, config?: AxiosRequestConfig | undefined): Promise<Types.MaterialDto> {
    let url_ = getBaseUrl() + "/api/material";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateMaterialDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreate,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreate?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreate(_response);
    });
}

function processCreate(response: AxiosResponse): Promise<Types.MaterialDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initMaterialDto(resultData200);
        return Promise.resolve<Types.MaterialDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MaterialDto>(null as any);
}

/**
 * Returns a list of the materials satisfied by search string.
If search string is null or empty, returns all materials.
 * @param search (optional) Search string.
 */
export function search(search?: string | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.MaterialDto[]> {
    let url_ = getBaseUrl() + "/api/material?";
    if (search !== undefined && search !== null)
        url_ += "search=" + encodeURIComponent("" + search) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSearch,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSearch?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSearch(_response);
    });
}

function processSearch(response: AxiosResponse): Promise<Types.MaterialDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initMaterialDto(item)
              );
            }
        return Promise.resolve<Types.MaterialDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MaterialDto[]>(null as any);
}

/**
 * Returns the user's own recipes that use the given material (most-recently-changed first,
capped) together with the total count, for the material card's "used in recipes" section.
 * @param materialId Id of the material to look up.
 */
export function getRecipesUsingMaterial(materialId: number, config?: AxiosRequestConfig | undefined): Promise<Types.MaterialUsageDto> {
    let url_ = getBaseUrl() + "/api/material/{materialId}/recipes";
    if (materialId === undefined || materialId === null)
      throw new Error("The parameter 'materialId' must be defined.");
    url_ = url_.replace("{materialId}", encodeURIComponent("" + materialId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetRecipesUsingMaterial,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetRecipesUsingMaterial?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetRecipesUsingMaterial(_response);
    });
}

function processGetRecipesUsingMaterial(response: AxiosResponse): Promise<Types.MaterialUsageDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initMaterialUsageDto(resultData200);
        return Promise.resolve<Types.MaterialUsageDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MaterialUsageDto>(null as any);
}

/**
 * Copies a material into the user's own materials, so they can adjust a formula they do not own.
 * @param materialId Id of the material to copy.
 * @return Dto with the copy's data.
 */
export function copy(materialId: number, config?: AxiosRequestConfig | undefined): Promise<Types.MaterialDto> {
    let url_ = getBaseUrl() + "/api/material/{materialId}/copy";
    if (materialId === undefined || materialId === null)
      throw new Error("The parameter 'materialId' must be defined.");
    url_ = url_.replace("{materialId}", encodeURIComponent("" + materialId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigCopy,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCopy?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCopy(_response);
    });
}

function processCopy(response: AxiosResponse): Promise<Types.MaterialDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initMaterialDto(resultData200);
        return Promise.resolve<Types.MaterialDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MaterialDto>(null as any);
}

/**
 * Deletes an existing material.
 * @param id Id of a material to delete.
 */
export function delete_(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/material/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDelete,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigDelete?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDelete(_response);
    });
}

function processDelete(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Patches existing material with new data.
 * @param id Id of the material to patch.
 * @param dto Dto with updated data of the material.
 */
export function patch(id: number, dto: Types.PatchMaterialDto, config?: AxiosRequestConfig | undefined): Promise<Types.MaterialDto> {
    let url_ = getBaseUrl() + "/api/material/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializePatchMaterialDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPatch,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigPatch?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPatch(_response);
    });
}

function processPatch(response: AxiosResponse): Promise<Types.MaterialDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initMaterialDto(resultData200);
        return Promise.resolve<Types.MaterialDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MaterialDto>(null as any);
}

/**
 * Adds Material to user's inventory.
 * @param materialId Id of the Material
 */
export function addMaterialToInventory(materialId: number, config?: AxiosRequestConfig | undefined): Promise<Types.MaterialDto> {
    let url_ = getBaseUrl() + "/api/material/inventory/{materialId}";
    if (materialId === undefined || materialId === null)
      throw new Error("The parameter 'materialId' must be defined.");
    url_ = url_.replace("{materialId}", encodeURIComponent("" + materialId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigAddMaterialToInventory,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigAddMaterialToInventory?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAddMaterialToInventory(_response);
    });
}

function processAddMaterialToInventory(response: AxiosResponse): Promise<Types.MaterialDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initMaterialDto(resultData200);
        return Promise.resolve<Types.MaterialDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MaterialDto>(null as any);
}

/**
 * Removes Material from user's inventory.
 * @param materialId Id of the Material
 */
export function removeMaterialFromInventory(materialId: number, config?: AxiosRequestConfig | undefined): Promise<Types.MaterialDto> {
    let url_ = getBaseUrl() + "/api/material/inventory/{materialId}";
    if (materialId === undefined || materialId === null)
      throw new Error("The parameter 'materialId' must be defined.");
    url_ = url_.replace("{materialId}", encodeURIComponent("" + materialId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemoveMaterialFromInventory,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigRemoveMaterialFromInventory?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemoveMaterialFromInventory(_response);
    });
}

function processRemoveMaterialFromInventory(response: AxiosResponse): Promise<Types.MaterialDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initMaterialDto(resultData200);
        return Promise.resolve<Types.MaterialDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.MaterialDto>(null as any);
}
let _requestConfigCreate: Partial<AxiosRequestConfig> | null;
export function getCreateRequestConfig() {
  return _requestConfigCreate;
}
export function setCreateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreate = value;
}
export function patchCreateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreate = patch(_requestConfigCreate ?? {});
}

let _requestConfigSearch: Partial<AxiosRequestConfig> | null;
export function getSearchRequestConfig() {
  return _requestConfigSearch;
}
export function setSearchRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSearch = value;
}
export function patchSearchRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSearch = patch(_requestConfigSearch ?? {});
}

let _requestConfigGetRecipesUsingMaterial: Partial<AxiosRequestConfig> | null;
export function getGetRecipesUsingMaterialRequestConfig() {
  return _requestConfigGetRecipesUsingMaterial;
}
export function setGetRecipesUsingMaterialRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetRecipesUsingMaterial = value;
}
export function patchGetRecipesUsingMaterialRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetRecipesUsingMaterial = patch(_requestConfigGetRecipesUsingMaterial ?? {});
}

let _requestConfigCopy: Partial<AxiosRequestConfig> | null;
export function getCopyRequestConfig() {
  return _requestConfigCopy;
}
export function setCopyRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCopy = value;
}
export function patchCopyRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCopy = patch(_requestConfigCopy ?? {});
}

let _requestConfigDelete: Partial<AxiosRequestConfig> | null;
export function getDeleteRequestConfig() {
  return _requestConfigDelete;
}
export function setDeleteRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDelete = value;
}
export function patchDeleteRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDelete = patch(_requestConfigDelete ?? {});
}

let _requestConfigPatch: Partial<AxiosRequestConfig> | null;
export function getPatchRequestConfig() {
  return _requestConfigPatch;
}
export function setPatchRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPatch = value;
}
export function patchPatchRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPatch = patch(_requestConfigPatch ?? {});
}

let _requestConfigAddMaterialToInventory: Partial<AxiosRequestConfig> | null;
export function getAddMaterialToInventoryRequestConfig() {
  return _requestConfigAddMaterialToInventory;
}
export function setAddMaterialToInventoryRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAddMaterialToInventory = value;
}
export function patchAddMaterialToInventoryRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAddMaterialToInventory = patch(_requestConfigAddMaterialToInventory ?? {});
}

let _requestConfigRemoveMaterialFromInventory: Partial<AxiosRequestConfig> | null;
export function getRemoveMaterialFromInventoryRequestConfig() {
  return _requestConfigRemoveMaterialFromInventory;
}
export function setRemoveMaterialFromInventoryRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemoveMaterialFromInventory = value;
}
export function patchRemoveMaterialFromInventoryRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemoveMaterialFromInventory = patch(_requestConfigRemoveMaterialFromInventory ?? {});
}